export const API_STATUS = {
  NEW: 'new',
  DEPRECATED: 'deprecated',
} as const;

export type ApiStatusType = (typeof API_STATUS)[keyof typeof API_STATUS];
export type ApiStatusDisplayType = ApiStatusType | null;

export interface ProductDoc {
  path: string;
  url: string;
  downloadUrl: string;
  title: string;
  id: string;
}

export interface ProductData {
  id: string;
  title: string;
  description: string;
  tag: string;
  type: string;
  docs: ProductDoc[];
  thumbnails: Array<{ path: string; url: string; downloadUrl: string }>;
  specs: Array<{
    path: string;
    version: string;
    url: string;
    downloadUrl: string;
  }>;
  new: boolean;
  deprecated: boolean;
  clientCredentials: string[];
}
